import * as types from './session.actionTypes';

const clearState = () => {
    return {
        type: types.CLEAR_STATE,
    };
};

export default clearState;
